import { render } from "./associationAdministrator.vue?vue&type=template&id=ce430dc8&scoped=true"
import script from "./associationAdministrator.vue?vue&type=script&lang=js"
export * from "./associationAdministrator.vue?vue&type=script&lang=js"

import "./associationAdministrator.vue?vue&type=style&index=0&id=ce430dc8&lang=scss&scoped=true"
import "./associationAdministrator.vue?vue&type=style&index=1&id=ce430dc8&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce430dc8"]])

export default __exports__